/**
 * @Author Awen
 * @Date 2024/06/01
 * @Email wengaolng@gmail.com
 **/

import GoCaptcha from './gocaptcha';

export default GoCaptcha
